module.exports = __webpack_public_path__ + "static/shyriaieva-a0e3d99c7ec3b1f8f224c99ba7ca5fd8.jpg";